import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateAssetType($companyId: ID!, $id: ID!, $attributes: AssetTypeAttributes!) {
    updateAssetType(companyId: $companyId, id: $id, attributes: $attributes) {
      assetType {
        id
        ...UpdatedAssetType
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedAssetType on AssetType {
    id
    name
    costCents
    rateCents
    availableToEvents
    displayOnWebsite
    description
    weight
    manufacturer
    model
    stockCount
    documentCategory {
      id
      name
      color
    }
    taxRate {
      id
      name
      rate
    }
    mystroTestId
  }
`
